module.exports = __webpack_public_path__ + "img/advance.8a122a04.png";